module.exports = __webpack_public_path__ + "static/media/022-man-5.81d84023.svg";